var map = {
	"./0.png": 7502,
	"./1.png": 1976,
	"./10.png": 2449,
	"./2.png": 5777,
	"./3.png": 3063,
	"./4.png": 3122,
	"./5.png": 8866,
	"./6.png": 3485,
	"./7.png": 6897,
	"./8.png": 9687,
	"./9.png": 2476
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4868;